import {
  ATTRIBUTE_VALUE_LABELS as IDB_ATTRIBUTE_VALUE_LABELS,
  OPTIONS as IDB_OPTIONS,
  QUESTIONS as IDB_QUESTIONS,
  STATEMENTS as IDB_STATEMENTS,
  VIEW_LABEL as IDB_VIEW_LABEL
} from './IDB/constants';
import {
  RETAINER_ATTRIBUTES,
  RETAINER_CUT_TYPE_LABELS,
  RETAINER_QUESTIONS,
  RETAINER_VIEW_LABEL
} from './Retainer/constants';

export const QUESTIONS = {
  ...IDB_QUESTIONS,
  ...RETAINER_QUESTIONS
};

export const VIEW_LABEL = {
  ...IDB_VIEW_LABEL,
  ...RETAINER_VIEW_LABEL
};

export const STATEMENTS = {
  ...IDB_STATEMENTS
};

export const OPTIONS = {
  ...IDB_OPTIONS
};

export const ATTRIBUTE_VALUE_LABELS = {
  ...IDB_ATTRIBUTE_VALUE_LABELS,
  [RETAINER_ATTRIBUTES.RETAINER_CUT_TYPE]: RETAINER_CUT_TYPE_LABELS
};
